import BasicModel from '../basic/BasicModel'
export default {
  findBaseBrandForCDSystem(vm, listener) {
    let action = 'carBase/findBaseBrandForCDSystem.action'
    BasicModel.post(vm, action, null, listener)
  },
  findBaseSeriesByBrandIdForCDSystem(vm, params, listener) {
    let action = 'carBase/findBaseSeriesByBrandIdForCDSystem.action'
    BasicModel.post(vm, action, params, listener)
  },
  findBaseCategoriesBySeriesIdForCDSystem(vm, params, listener) {
    let action = 'carBase/findBaseCategoriesBySeriesIdForCDSystem.action'
    BasicModel.post(vm, action, params, listener)
  },
  getCategoryListBySeriesId(vm,params,listener){
    let action = 'carBase/getCategoryListBySeriesId.action'
    BasicModel.post(vm, action, params, listener)
  },
  selectBrandFactoryList(vm,listener){
    let action = 'carBase/findBrandFactoryList.action'
    BasicModel.get(vm, action, null, listener)
  },
  // 限制品牌区域
  findBaseSeriesByBrandIdForCDSystemByFilter(vm, params, listener) {
    let action = 'carBase/findBaseSeriesByBrandIdForCDSystemByFilter.action'
    BasicModel.post(vm, action, params, listener)
  },
  getCategoryListBySeriesIdByFilter(vm,params,listener){
    let action = 'carBase/getCategoryListBySeriesIdByFilter.action'
    BasicModel.post(vm, action, params, listener)
  },
  findBaseBrandForCDSystemByFilter(vm,params, listener) {
    let action = 'carBase/findBaseBrandForCDSystemByFilter.action'
    BasicModel.post(vm, action, params, listener)
  },
}
